<template>
	<!-- 企业管理-->
	<div class="public_Spacing systemCorporateAccount">
		<div class="pulbic_oparetionBlock">
			<div class="public_criteriaRange systemCorporateAccount-display">
				<div class="public_oparetionBlock_Menu systemCorporateAccount-wuliao-input">
					<span class="public_lbSty">检索：</span>
					<input type="text" v-model="retrievalQuery" placeholder="请输入厂区名称或手机号" />
				</div>
			</div>
			<div class="public_operatArea" style="margin-left: 0;">
				<div class="public_operatBtn" style="margin-left: 0;">
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="queryClick">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
					<el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="新增"
						@click="newlyAdd">
						<i class="iconfont icon-tianjia1"></i>新增
					</el-button>
				</div>
			</div>

		</div>

		<div class="systemCorporateAccount-table pulbic_oparetionBlock pulbic_table_container">
			<el-table :data="tableData" @cell-click="tabClick" :row-class-name="tableRowClassName"
				:cell-class-name="tableCellClassName" style="width: 100%;" max-height="90%" stripe
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn">
				<el-table-column align="center" prop="SETTB100CA00" label="一级企业"></el-table-column>
				<el-table-column align="center" prop="SETTB99CA00" label="二级企业"></el-table-column>
				<el-table-column align="center" prop="SETTB99CA05" label="联系电话"></el-table-column>
				<el-table-column align="center" prop="SETTB99CA02" label="地址"></el-table-column>
				<el-table-column align="center" prop="ORMTB401CA02" label="账户名称"></el-table-column>
				<el-table-column align="center" prop="ORMTB401CA16" width="130" label="账户手机号"></el-table-column>
				<el-table-column align="center" prop="ORMTB401CA03" label="账户余额"></el-table-column>
				
				<el-table-column align="center" prop="notice" label="公告">
						<template slot-scope="scope">
							<span v-if="
				  scope.row.index === clickRowIndex &&
				  scope.column.index === clickCellIndex
				">
								<el-input v-model="scope.row.notice" maxlength="300" placeholder="公告" size="mini"
									@blur="inputBlur" @change="changeInput(scope.row)" />
							</span>
							<span v-else="scope.row.showInput">{{scope.row.notice}}</span>
				
				
						</template>
					</el-table-column>
				<el-table-column align="center" prop="SETTB100CA03text" label="厂家类别">
					
					
				</el-table-column>
				<!-- <el-table-column align="center" prop="" label="绑定状态"></el-table-column> -->
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						<div>绑定状态</div>
					</template>
					<template slot-scope="scope">
						<div v-if="scope.row.ORMTB401CA04!=undefined">
							已绑定
						</div>
						<div v-else>
							未绑定
						</div>
					</template>
				</el-table-column>
				

				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						<div>抹零状态</div>
					</template>
					<template slot-scope="scope">
						<div v-if="scope.row.ORMTB401CA08">
							<el-tag size="small" type="success">
								已启用
							</el-tag>
						</div>

						<div v-else>
							<el-tag size="small" type="warning">
								未启用
							</el-tag>
						</div>
					</template>
				</el-table-column>

				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						<div>在网状态</div>
					</template>
					<template slot-scope="scope">
						<div v-if="scope.row.ORMTB401CA13 =='0'">
							<el-tag size="small" type="success">
								在线
							</el-tag>
						</div>

						<div v-if="scope.row.ORMTB401CA13 =='1'">
							<el-tag size="small" type="danger">
								离线
							</el-tag>
						</div>
						<div v-if="scope.row.ORMTB401CA13 =='2'">
							<el-tag size="small" type="info">
								暂无状态
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						<div>厂家状态</div>
					</template>
					<template slot-scope="scope">
						<div v-if="scope.row.ORMTB401CA09=='0'">
							<el-tag size="small" type="success">
								已上架
							</el-tag>
						</div>

						<div v-else>
							<el-tag size="small" type="danger">
								已下架
							</el-tag>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="操作" align="center" width="360">
					<template slot-scope="scope">
						<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="info"
							size="small" @click="materialJGClick(scope.row)" v-if="scope.row.ORMTB401CA04!=undefined"
							v-shiroHiden="solelist" id="查看物料">
							查看价格
						</el-button>
						<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info"
							size="small" @click="materialClick(scope.row)" v-if="scope.row.ORMTB401CA04!=undefined"
							v-shiroHiden="solelist" id="查看物料">
							查看物料
						</el-button>
						<el-button class="public_icon_qiyong  public_icon_margin" type="info" size="small"
							@click="captchaBinding(scope.row)" v-if="scope.row.ORMTB401CA04==undefined"
							v-shiroHiden="solelist" id="验证码绑定">
							验证码绑定
						</el-button>
						<el-button class="public_icon_xiugai public_icon_width public_icon_margin"
							v-shiroHiden="solelist" id="修改" type="info" size="small" @click="modify(scope.row)">
							修改
						</el-button>
						<!-- <el-button class="public_icon_xiugai public_icon_width public_icon_margin"
							v-shiroHiden="solelist" id="修改" type="info" size="small" @click="modify(scope.row)">
							调零售价
						</el-button> -->

						<!-- <el-button v-if="scope.row.ORMTB401CA09=='0'"
							class="public_icon_qiyong public_icon_width public_icon_margin" type="info" size="small"
							@click="undercarriageClick(scope.row)">
							下架
						</el-button>
						<el-button v-if="scope.row.ORMTB401CA09=='1'"
							class="public_icon_dayin public_icon_width public_icon_margin" type="success" size="small"
							@click="groundingClick(scope.row)">
							上架
						</el-button> -->

						<el-dropdown style="padding-left: 20px;" v-shiroHiden="solelist" id="设置">
							<span class="el-dropdown-link public_icon_qiyong">
								设置<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
									<el-button v-if="scope.row.ORMTB401CA09=='0'"
										class="public_icon_qiyong public_icon_width public_icon_margin" type="info"
										size="small" @click="undercarriageClick(scope.row)">
										下架
									</el-button>
									<el-button v-if="scope.row.ORMTB401CA09=='1'"
										class="public_icon_dayin public_icon_width public_icon_margin" type="success"
										size="small" @click="groundingClick(scope.row)">
										上架
									</el-button>
								</el-dropdown-item>

								<el-dropdown-item>
									<el-button v-if="scope.row.ORMTB401CA13=='0'"
										class="public_icon_qiyong public_icon_width public_icon_margin" type="info"
										size="small" @click="wlztClick(scope.row,1)">
										离线
									</el-button>
									<el-button v-if="scope.row.ORMTB401CA13=='1'"
										class="public_icon_dayin public_icon_width public_icon_margin" type="success"
										size="small" @click="wlztClick(scope.row,0)">
										在线
									</el-button>
								</el-dropdown-item>
								<el-dropdown-item>
									<el-button class="public_icon_qiyong public_icon_width public_icon_margin"
										type="info" size="small" @click="materialMLClick(scope.row)"
										v-if="!scope.row.ORMTB401CA08">
										启用抹零
									</el-button>
									<el-button class="public_icon_qiyong public_icon_width public_icon_margin"
										type="info" size="small" @click="modifyMLClick(scope.row)"
										v-if="scope.row.ORMTB401CA08">
										修改抹零
									</el-button>
									<el-button class="public_icon_jinyong public_icon_width public_icon_margin"
										type="danger" size="small" @click="preservationGBML(scope.row)">
										关闭抹零
									</el-button>
								</el-dropdown-item>

                <el-dropdown-item>
                  <el-button v-if="scope.row.ORMTB401CA01=='ZJ'"
                             class="public_icon_qiyong public_icon_width public_icon_margin" type="info"
                             size="small" @click="addAmountClick(scope.row)">
                    充值
                  </el-button>
                </el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>

					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limit"
					layout="total,sizes, prev, pager, next" :total="pagingPage"></el-pagination>
			</div>
		</div>
		<!-- 查看价格-->
		<div class="public-dialog">
			<el-dialog :title="jgcjtitle+'价格信息'" :visible.sync="insertJGShow" width="50%" height="600px"
				:closeOnClickModal='false'>
				<!-- <div class="" :style="{height: chartHeight + 'px',Width:chartWidth+'px'}">
					<div id="JGChart" ref="main" style="height:100%;"></div>
				</div> -->

				<!-- <div>
					<el-table :data="tableStudentData" :span-method="reconstructionStuCell" border style="width: 100%">
						<el-table-column type="index" label="序号" width="50"></el-table-column>
						<el-table-column prop="name" label="姓名" width="80"></el-table-column>
						<el-table-column label="科目信息">
							<el-table-column prop="courseName" label="科目" width="80"></el-table-column>
							<el-table-column prop="date" label="日期" width="80"></el-table-column>
							<el-table-column prop="timeStr" label="考试时间" width="100"></el-table-column>
						</el-table-column>
						<el-table-column label="成绩信息">
							<el-table-column prop="score" label="成绩" width="60"></el-table-column>
							<el-table-column prop="scoreTotal" label="总分" width="60"></el-table-column>
							<el-table-column prop="total" label="满分" width="60"></el-table-column>
							<el-table-column prop="totalAll" label="满分总分" width="100">
								<template slot-scope="scope">
									<span v-if="scope.row.totalAll">{{scope.row.totalAll}}
										（及格率：{{parseInt(scope.row.scoreTotal/scope.row.totalAll*100)}}%）</span>
								</template>
							</el-table-column>
						</el-table-column>
					</el-table>

				</div> -->

				<el-table :data="tableData1" height="850" :row-class-name="tableRowClassName"
					:cell-class-name="tableCellClassName" stripe :span-method="objectSpanMethod" border
					style="width: 100%; margin-top: 20px">
					<el-table-column prop="name" label="物料" width="100" align="center">
					</el-table-column>
					<el-table-column prop="jb" label="级别" align="center">
					</el-table-column>
					<el-table-column prop="djkj" label="单价扣减" align="center">
					</el-table-column>
					<el-table-column prop="zczk" label="整车折扣" align="center">
					</el-table-column>
					<el-table-column prop="zcyh" label="整车优惠" align="center">
					</el-table-column>
				</el-table>


			</el-dialog>
		</div>
		<!-- 启用抹零设置 -->
		<div class="public-dialog">
			<el-dialog title="启用抹零" :visible.sync="insertMLShow" width="60%" :closeOnClickModal='false'>
				<!-- <div class="systemCorporateAccount-dialog"> -->
				<!-- <div class="systemCorporateAccount-dialog-btn"> -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
					<el-form-item label="客户等级" prop="grade">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAllGrade"
							@change="handleCheckAllChange">全选</el-checkbox>

						<el-checkbox-group v-model="checkedCitiesGrade" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="(city,i) in ruleForm.grade" :label="city" :key="i">
								{{city.SETTB206CA01}}
							</el-checkbox>

						</el-checkbox-group>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button type="primary" @click="preservationML">保存</el-button>
						<el-button type="warning" @click="insertMLShow=false">取消</el-button>
					</el-form-item>
				</el-form>
				<!-- </div> -->
				<!-- </div> -->
			</el-dialog>
		</div>

		<!-- 修改抹零设置 -->
		<div class="public-dialog">
			<el-dialog title="修改抹零" :visible.sync="insertXGMLShow" width="60%" :closeOnClickModal='false'>
				<!-- <div class="systemCorporateAccount-dialog"> -->
				<!-- <div class="systemCorporateAccount-dialog-btn"> -->
				<el-form label-width="auto" class="demo-ruleForm">
					<el-form-item label="客户等级" prop="grade">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAllGrade"
							@change="handleCheckAllChange">全选</el-checkbox>

						<el-checkbox-group v-model="checkedCitiesGrade" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="(city,i) in editRuleForm.grade" :label="city.SETTB206CA00"
								:key="city.SETTB206CA00">
								{{city.SETTB206CA01}}
							</el-checkbox>

						</el-checkbox-group>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button type="primary" @click="preservationXGML">保存</el-button>
						<el-button type="warning" @click="insertXGMLShow=false">取消</el-button>
					</el-form-item>
				</el-form>
				<!-- </div> -->
				<!-- </div> -->
			</el-dialog>
		</div>


		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增" :visible.sync="insertShow" width="40%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">APP展示企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseNameAdd" placeholder="请输入" />
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业简称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseAbbreviationAdd" placeholder="请输入" />
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">手机号<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="11" v-model="phoneNumberAdd" placeholder="请输入"
								v-on:input="phoneNumberAdd=phoneNumberAdd.replace(/[^\d]/g,'')" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="accountNameAdd" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户余额<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="accountBalanceAdd" placeholder="请输入"
								@keyup="accountBalanceAddUp" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">地址<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="addressBalanceAdd" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">市名称<span>*</span></div>
						<div class="SCADL-input">
							<el-select class="SCADL-select" v-model="cityCodeAdd" @change="cityNameChange" filterable>
								<el-option v-for="item in cityNameList" :key="item.CODETB01CA00"
									:label="item.CODETB01CA01" :value="item.CODETB01CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">公告</div>
						<div class="SCADL-input">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"
								v-model="notice">
							</el-input>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">派单审核<span>*</span></div>
						<div class="SCADL-input">
							<el-select v-model="uditTypeAdd">
							    <el-option
							      v-for="item in auditList"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							  </el-select>
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationAdd">保存</el-button>
						<el-button type="warning" @click="insertShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="编辑" :visible.sync="updateShow" width="40%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">APP展示企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseNameModify" v-if="modifyIF=='BD'" readonly />
							<input type="text" v-model="enterpriseNameModify" placeholder="请输入" v-else />
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业简称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseAbbreviationModify" placeholder="请输入" />
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">手机号<span>*</span></div>
						<div class="SCADL-input">
							<!-- v-on:input="phoneNumberModify=phoneNumberModify.replace(/[^\d]/g,'')" -->
							<!-- readonly -->
							<input type="text" maxlength="11" v-model="phoneNumberModify" placeholder="请输入"
								v-if="modifyIF=='BD'" />
							<input type="text" v-else maxlength="11" v-model="phoneNumberModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户名称<span>*</span></div>
						<div class="SCADL-input">
							<input v-if="modifyIF=='BD'" readonly type="text" v-model="accountNameModify"
								placeholder="请输入" />
							<input type="text" v-else v-model="accountNameModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户余额<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="accountBalanceModify" v-if="modifyIF=='BD'" readonly
								placeholder="请输入" />
							<input type="text" v-model="accountBalanceModify" v-else placeholder="请输入"
								@keyup="accountBalanceModifyUp" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">地址<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="addressBalanceModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">市名称<span>*</span></div>
						<div class="SCADL-input">
							<el-select class="SCADL-select" v-model="cityCodeModify" @change="cityNameChangeModify"
								filterable>
								<el-option v-for="item in cityNameList" :key="item.CODETB01CA00"
									:label="item.CODETB01CA01" :value="item.CODETB01CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">厂家类别<span>*</span></div>
						<div class="SCADL-input">
							<el-select v-model="uditTypeUpdate">
								<el-option v-for="item in auditList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">公告</div>
						<div class="SCADL-input">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"
								v-model="notice">
							</el-input>
						</div>
					</div> -->

					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationModify">保存</el-button>
						<el-button type="warning" @click="updateShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="账户绑定" :visible.sync="bindingShow" width="30%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">主手机号<span>*</span></div>
						<div class="SCADL-input">
							<input type="tel" v-model="phoneBinding" placeholder="请输入" maxlength="11"
								v-on:input="phoneBinding=phoneBinding.replace(/[^\d]/g,'')"
								@input="phoneBindingUp">
								
						</div>
					</div>

					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">子账户<span>*</span></div>
						<el-select class="SCADL-input SCADL-btn Binding-input"
							v-model="nameBinding" @change="erpChange" placeholder="请选择">
							<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB107ID"
								:label="item.SETTB107CA00" :value="item">
							</el-option>
						</el-select>
					</div>

					<!-- <div class="systemCorporateAccount-dialog-li" style="flex-direction: row;align-items: center;">
						<div class="SCADL-text">账户名称<span></span></div>
						<div class="SCADL-input">
							{{nameBinding}}
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">子手机号</div>
						<div class="SCADL-input SCADL-btn Binding-input">
							<input type="text" v-model="zzhphoneBinding" placeholder="请输入" maxlength="11"
								v-on:input="zzhphoneBinding=zzhphoneBinding.replace(/[^\d]/g,'')">
							<el-button type="success" @click='phoneBindingUp'>认证
							</el-button>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">验证码<span>*</span></div>
						<div class="SCADL-input SCADL-btn Binding-input">
							<!-- <input type="text" v-model="codeNumBinding" placeholder="请输入验证码"  maxlength="6"> -->
							<el-input placeholder="验证码" v-model="codeNumBinding">
								<i slot="prefix" class="el-input__icon el-icon-circle-check"></i>
							</el-input>
							<el-button type="primary" :disabled='checkDisable' @click='countdown'>{{checkText}}
							</el-button>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationBinding">保存</el-button>
						<el-button type="warning" @click="bindingShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="查看物料" :visible.sync="materShow" width="65%" :closeOnClickModal='false'>
				<div class="public-chech systemCorporateAccount-dialog">
					<div class="public-chech-details">
						<div class="public-chech-details-tile">
							<div class="public-chech-details-tile-pre">物料类型：</div>
							<div class="public-chech-details-tile-pre-sel systemCorporateAccount-wuliao-input">
								<el-select v-model="categoryMaterial">
									<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00"
										:label="item.SETTB206CA01" :value="item.SETTB206CA00">
									</el-option>
								</el-select>
								<!-- <input type="text" v-model="categoryMaterial" placeholder="请输入" /> -->
							</div>
							<div class="public-chech-details-tile-q">物料名称：</div>
							<div class="public-chech-details-tile-q-sel systemCorporateAccount-wuliao-input">
								<!-- <el-select >
									<el-option v-for="item in resTerpList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select> -->
								<input type="text" v-model="nameMaterial" placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-operation-btn">
							<el-button type="primary" @click="MaterialQuery">查询</el-button>
							<el-button type="warning" class="systemCorporateAccount-dialog-operation-btn-add"
								v-if="materiaShowZJ=='ZJ'" @click="MaterialAdd">新增</el-button>
						</div>
						<div class="pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="materList" style="width: 100%" stripe max-height="90%"
								class="public_tableColumn"
								:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
								<!-- <el-table-column type="expand" align="center">
									<template slot-scope="props">
										<el-form label-position="left" inline class="demo-table-expand">
											<el-form-item label="级别">
												<span>{{ props.row.name }}</span>
											</el-form-item>
											<el-form-item label="单价扣减">
												<span>{{ props.row.shop }}</span>
											</el-form-item>
											<el-form-item label="整车折扣">
												<span>{{ props.row.id }}</span>
											</el-form-item>
											<el-form-item label="整车优惠">
												<span>{{ props.row.shopId }}</span>
											</el-form-item>
										</el-form>
									</template>
								</el-table-column> -->
								<el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
								<el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
								<!-- <el-table-column v-if="materiaShowZJ=='ZJ'" align="center" prop="SETTB109CA03" label="物料类型"></el-table-column> -->
								<el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column>
								<el-table-column align="center" prop="SETTB109CA01" label="零售价格"></el-table-column>
								<el-table-column align="center" prop="ORMTB402CA00" label="合同价格"></el-table-column>
								<!-- <el-table-column align="center" prop="" label="协议价格"></el-table-column> -->
								<el-table-column align="center" prop="SETTB109CA02" label="状态"></el-table-column>
								<el-table-column align="center" prop="SETTB109CA05" label="计量单位"></el-table-column>
								<el-table-column align="center" prop="SETTB109CB06" label="高度">
									<template slot-scope="scope">
										<span v-if="scope.row.SETTB109CB06">{{scope.row.SETTB109CB06}}</span>
										<span v-else>暂无数据</span>
									</template>

								</el-table-column>
								<!-- <el-table-column align="center" label="展示视频">
									<template slot-scope="scope">
										<video v-if="scope.row.SETTB109CA07" controls width="960" :src="scope.row.SETTB109CA07" style="width:50px;height: 50px;"></video>
										<span v-else>暂无</span>
									</template>
								</el-table-column>
								<el-table-column align="center" label="待审核视频" width="100">
									<template slot-scope="scope">
										<video v-if="scope.row.SETTB109CA09" controls width="960" :src="scope.row.SETTB109CA09" style="width: 50px;height: 50px;"></video>
										<span v-else>暂无</span>
									</template>
								</el-table-column> -->
								<el-table-column align="center" label="是否优惠">
									<template slot-scope="scope">
										<el-switch @change="changeTable(scope.row)" :width="switchWidth"
											inactive-color="rgba(255, 90, 69, 1)" active-value="1"
											v-model="scope.row.SETTB109CA08" inactive-value="0"></el-switch>
									</template>
								</el-table-column>
								<el-table-column align="center" label="多账户">
									<template slot-scope="scope">
										<el-switch @change="changeMultipleAccountsTable(scope.row)" :width="switchWidth"
											inactive-color="rgba(255, 90, 69, 1)" active-value="1"
											v-model="scope.row.SETTB109CB09" inactive-value="0"></el-switch>
									</template>
								</el-table-column>
								<!-- <el-table-column align="center" width="230" label="优惠金额设置">
									<template slot-scope="scope">
										<el-input-number :precision="2"
										 :step="1" :min="0" :max="100" v-model="djkj"></el-input-number>元
									</template>
								</el-table-column> -->
								<el-table-column align="center" label="操作" width="260">
									<template slot-scope="scope">
										<!-- && materiaShowZJ=='ZJ' -->
										<el-button class="public_icon_jinyong public_icon_margin public_icon_width"
											type="danger" v-if="scope.row.SETTB109CA02=='启用'&&scope.row.SETTB109CB04==1"
											@click="disableClick(scope.row)" size="small" id="禁用">
											禁用
										</el-button>
										<el-button class="public_icon_qiyong public_icon_width public_icon_margin"
											type="info" v-if="scope.row.SETTB109CA02=='禁用'&&scope.row.SETTB109CB04==0"
											size="small" @click="disableClick(scope.row)" id="启用">
											启用
										</el-button>
										<el-dropdown v-if="scope.row.SETTB109CA11 =='0'">
											<span class="el-dropdown-link public_icon_qiyong">
												视频审核<i class="el-icon-arrow-down el-icon--right"></i>
											</span>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item>
													<el-button
														class="public_icon_chongzhi public_icon_width public_icon_margin"
														type="primary" size="small" @click="tgClick(scope.row)" id="通过">
														通过</el-button>
												</el-dropdown-item>
												<el-dropdown-item>
													<el-button
														class="public_icon_hongchongred public_icon_width public_icon_margin"
														type="danger" size="small" @click="HCclick(scope.row)" id="拒绝">
														拒绝
													</el-button>
												</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>

										<el-button v-if="scope.row.SETTB109CA02=='启用'"
											class="public_icon_xiugai public_icon_width" type="info" size="small"
											@click="DiscountModify(scope.row)" id="优惠调控">
											优惠调控
										</el-button>
										<el-button class="public_icon_jinyong public_icon_width" type="primary"
											size="small" v-if="materiaShowZJ=='ZJ'||scope.row.SETTB109CB11=='1'"
											@click="MaterialModify(scope.row)" id="修改">
											修改
										</el-button>
										<!-- <el-button class="public_icon_jinyong public_icon_width" type="primary"
											size="small" v-if="materiaShowZJ=='ZJ'||scope.row.SETTB109CB11=='1'"
											@click="MaterialModify(scope.row)" id="修改">
											调零售价
										</el-button> -->
										<el-button class="public_icon_qiyong public_icon_width" type="info" size="small"
											@click="locationSet(scope.row)" id="优惠调控">
											库位设置
										</el-button>

									</template>
								</el-table-column>
							</el-table>
							<div class="pulbic_pagesize">
								<el-pagination @size-change="handleSizeChangeMaterial"
									@current-change="handleCurrentChangeMaterial"
									:current-page.sync="currentPageMaterial" :page-sizes="[10, 20, 30, 40]"
									:page-size="limitMaterial" layout="total,sizes, prev, pager, next"
									:total="pagingPageMaterial"></el-pagination>
							</div>
						</div>
					</div>
					<!-- <div class="public-dialog-btn">
						<el-button type="primary" @click="">保存</el-button>
						<el-button type="warning" @click="materShow=false">取消</el-button>
					</div> -->
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="新增" :visible.sync="materInsertShow" width="25%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterNameMaterialAdd" placeholder="请输入" readonly>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="nameMaterialAdd" placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">零售价格<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="wholesalePriceAdd" placeholder="请输入"
								@keyup="wholesalePriceAddUp">
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">协议价格<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="agreementPriceAdd" placeholder="请输入" @keyup="agreementPriceAddUp">
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">装车方式<span>*</span></div>
						<div class="SCADL-input">
							<!-- <el-select  v-model="materialTypeAdd">
								<el-option v-for="item in resTerpList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select> -->
							<!-- <input type="text" v-model="materialTypeAdd" placeholder="请输入"> -->
							<el-select v-model="materialTypeAdd">
								<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00"
									:label="item.SETTB206CA01" :value="item.SETTB206CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料类型<span>*</span></div>
						<div class="SCADL-input">
							<!-- <el-select  v-model="materialTypeAdd">
								<el-option v-for="item in resTerpList" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select> -->
							<!-- <input type="text" v-model="materialTypeAdd" placeholder="请输入"> -->
							<el-select v-model="carNameModify">
								<el-option v-for="item in customerManagementList" :key="item.SETTB206CA00"
									:label="item.SETTB206CA01" :value="item.SETTB206CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">计量单位<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="unitMeasurementAdd" placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationMaterialAdd">保存</el-button>
						<el-button type="warning" @click="materInsertShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="编辑" :visible.sync="materupdateShow" width="30%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterNameMaterialModify" placeholder="请输入" readonly>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="nameMaterialModify" placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">价格<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="wholesalePriceModify" placeholder="请输入"
								@keyup="wholesalePriceModifyUp">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">调价执行时间</div>
						<div class="SCADL-input">
							 <el-date-picker style="width: 100%;" v-model="tjzxsj" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" size="large" placeholder="选择日期时间"></el-date-picker>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">协议价格<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="agreementPriceModify" placeholder="请输入" @keyup="agreementPriceModifyUp">
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料类型<span>*</span></div>
						<div class="SCADL-input">
							<!-- <input type="text" v-model="materialTypeModify" placeholder="请输入"> -->
							<el-select v-model="materialTypeModify">
								<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00"
									:label="item.SETTB206CA01" :value="item.SETTB206CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">计量单位<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="unitMeasurementModify" placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationMaterialModify">保存</el-button>
						<el-button type="warning" @click="materupdateShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="优惠调控" :visible.sync="discountShow" width="30%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input :disabled="disabled" type="text" v-model="enterNameMaterialModify" placeholder="请输入"
								readonly>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料名称<span>*</span></div>
						<div class="SCADL-input">
							<input :disabled="disabled" type="text" v-model="nameMaterialModify" placeholder="请输入">
						</div>
					</div>
					
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">调价执行时间</div>
						<div class="SCADL-input">
							 <el-date-picker style="width: 100%;" v-model="yhtktjzxsj" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" size="large" placeholder="选择日期时间"></el-date-picker>
						</div>
					</div>
					
					
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">浮动类型<span>*</span></div>
						<div class="SCADL-input">
							<el-radio v-model="floatingType" label="1">上浮</el-radio>
							<el-radio v-model="floatingType" label="2">下调</el-radio>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">浮动金额<span>*</span></div>
						<div class="SCADL-input levelmang-table-KJ public-chech-details">

							<!-- <el-input v-model="floatingAmount" @keyup="wholesalePriceModifyUp" placeholder="请输入">
							    <template slot="append">元</template>
							  </el-input> -->
							<el-input-number style="text-align: center;" :precision="2" :step="1" :min="0" :max="100"
								v-model="floatingAmount"></el-input-number>元
							<!-- <input type="text" v-model="wholesalePriceModify" placeholder="请输入"> -->
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">协议价格<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="agreementPriceModify" placeholder="请输入" @keyup="agreementPriceModifyUp">
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料类型<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="materialTypeModify" placeholder="请输入">
							<el-select v-model="materialTypeModify">
								<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00" :label="item.SETTB206CA01" :value="item.SETTB206CA00">
								</el-option>
							</el-select>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">计量单位<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="unitMeasurementModify" placeholder="请输入">
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationDiscountModify">保存</el-button>
						<el-button type="warning" @click="discountShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="库位信息设置" :visible.sync="locationShow" width="25%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input :disabled="disabled" type="text" v-model="locationSetObj.SETTB99CA00"
								placeholder="请输入" readonly>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料名称<span>*</span></div>
						<div class="SCADL-input">
							<input :disabled="disabled" type="text" v-model="locationSetObj.SETTB109CA00"
								placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li" v-if="locationSetObj.SETTB206CA01=='铲车'">
						<div class="SCADL-text">库位信息<span>*</span></div>
						<div class="SCADL-input">
							<el-select v-model="locationSetObj.SETTB109CB06" placeholder="请选择">
								<el-option v-for="item in kwSelectArr" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li" v-if="locationSetObj.SETTB206CA01=='料仓'">
						<div class="SCADL-text">库位信息<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="locationSetObj.SETTB109CB06" placeholder="请输入">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="locationSetObjModify">保存</el-button>
						<el-button type="warning" @click="locationShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
    <!--    充值弹窗-->
    <div class="public-dialog">
      <el-dialog title="充值" :visible.sync="addAmountShow" width="40%"
                 @close="CZmoney='',amountCapitalText=''" :closeOnClickModal='false'>
        <div style="max-height: 500px;overflow-y: auto;">
          <div class="CustomerfillingDig-tab">
            <div class="CustomerfillingDig-tab-li">
              <div class="CustomerfillingDig-tab-li-text">企业名称：</div>
              <div class="CustomerfillingDig-tab-li-ipt">{{objaccount.SETTB99CA00}}</div>
              <div class="CustomerfillingDig-tab-li-b"></div>
            </div>
            <div class="CustomerfillingDig-tab-li">
              <div class="CustomerfillingDig-tab-li-text">账户名称：</div>
              <div class="CustomerfillingDig-tab-li-ipt">{{objaccount.ORMTB401CA02}}</div>
              <div class="CustomerfillingDig-tab-li-b"></div>
            </div>
            <div class="CustomerfillingDig-tab-li">
              <div class="CustomerfillingDig-tab-li-text">余额：</div>
              <div class="CustomerfillingDig-tab-li-ipt">{{objaccount.ORMTB401CA03}}</div>
              <div class="CustomerfillingDig-tab-li-b"></div>
            </div>
            <div class="CustomerfillingDig-tab-li">
              <div class="CustomerfillingDig-tab-li-text">充值金额：</div>
              <div class="CustomerfillingDig-tab-li-ipt">
                <!-- ref="HCmoney" -->
                <el-input type="text" v-model="CZmoney" maxlength="12" @input="topMoneyInput" style="margin-top: 11px"
                          @change="topMoneyChange"></el-input>
              </div>
              <div class="CustomerfillingDig-tab-li-b">*必填*</div>
            </div>
            <div class="CustomerfillingDig-priceNumtext">
              金额大写：<span>{{amountCapitalText}}</span>
            </div>
            <div class="CustomerfillingDig-tab-btn">
              <el-button type="primary" @click="CZserve()">确认</el-button>
              <el-button type="warning" @click="addAmountShow=false">取消</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				auditList: [{
					value: '0',
					label: '直连'
				}, {
					value: '1',
					label: '自建'
				}],
				clickRowIndex: null, // 当前点击的行索引
				clickCellIndex: null, // 当前点击的列索引
				tabClickLabel: "", // 当前点击的列名
				floatingType: '', //浮动类型-上浮-下浮
				floatingAmount: '', //浮动金额
				disabled: true,
				switchWidth: 30,
				userobj: this.$store.state.uobj, //登陆缓存--用户信息
				retrievalQuery: '',
				tableData: [], //列表table数据--查询
				page: 1, //默认列表页码
				limit: 10, //每页的条数
				pagingPage: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 新增
				insertShow: false,
				insertMLShow: false,
				addAmountShow:false,//充值
				isIndeterminate: false, // 客户等级全选
				checkAllGrade: false, //客户等级
				checkedCitiesGrade: [], //绑定默认选中客户等级

				ruleForm: {
					grade: [] //客户等级
				},
				editRuleForm: {
					grade: [] //客户等级
				},
				rules: {
					grade: [{
						required: true,
						message: '请选择客户等级',
						trigger: 'change'
					}]
				},
				addEdit: 0,
				objCjMasg: {},
				jgData: {},
				chartHeight: 1000,
				chartWidth: 300,
				insertXGMLShow: false,
				insertJGShow: false,
				enterpriseNameAdd: '', //企业名称
				// enterpriseAbbreviationAdd: '', //企业简称
				phoneNumberAdd: '', //手机号
				accountNameAdd: '', //账户名称
				accountBalanceAdd: '', //账户余额
				addressBalanceAdd: '', //地址
				notice: '',
				// uditTypeAdd: '1',//派单审核
				cityNameList: [],
				cityCodeAdd: '',
				cityNameAdd: '',
				djkj: '',
				// 修改
				updateShow: false,
				enterpriseNameModify: '', //企业名称
				// enterpriseAbbreviationModify: '', //企业简称
				phoneNumberModify: '', //手机号
				accountNameModify: '', //账户名称
				addressBalanceModify: '', //地址
				accountBalanceModify: '', //账户余额
				uditTypeUpdate: '1',
				ORMTB401ID: '', //帐户ID
				ORMTB401CA00: '', //一级企业ID
				SETTB99ID: '', //二级企业ID
				cityCodeModify: '',
				cityNameModify: '',
				modifyIF: '', //判断绑定，自建企业修改时可操作的字段
				// 账户绑定
				bindingShow: false,
				phoneBinding: '', //手机号
				zzhphoneBinding: '', //子账户手机号
				nameBinding: '', //账户名称
				codeNumBinding: '', //验证码
				SETTB107ID: '',
				SETTB116ID: '',
				SETTB116CA01: '',
				SETTB116CA00: '',
				checkDisable: false,
				checkText: '获取验证码',
				checkTextrz: '认证',
				countdownNum: 60,
				// 查看物料
				materShow: false,
				materList: [],
				materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
				categoryMaterial: '', //物料类别
				nameMaterial: '', //物料名称
				pageMaterial: 1, //默认列表页码
				limitMaterial: 10, //每页的条数
				pagingPageMaterial: 0, //分页--数据列表共有的条数
				currentPageMaterial: 1, //设置当前页默认为1
				// 新增
				materInsertShow: false,
				enterNameMaterialAdd: '', //企业名称
				nameMaterialAdd: '', //物料名称
				wholesalePriceAdd: '', //零售价格
				// agreementPriceAdd:'', //协议价格
				materialTypeAdd: '', //物料类型
				materialTypeList: [],
				unitMeasurementAdd: '', //计量单位
				// 修改
				materupdateShow: false,
				discountShow: false,
				enterNameMaterialModify: '', //企业名称
				nameMaterialModify: '', //物料名称
				wholesalePriceModify: '', //零售价格
				// agreementPriceModify:'', //协议价格
				materialTypeModify: '', //物料类型
				unitMeasurementModify: '', //计量单位
				MaterialModify109ID: '', //物料ID
				wholesalePriceBefore: '', //修改之前的价格
				bb: {},
				locationShow: false,
				locationSetObj: {},
				kwSelectArr: [{
					value: '有料',
					label: '有料'
				}, {
					value: '无料',
					label: '无料'
				}],
				kwSelectVal: '',
				tableData1: [{
						id: '小12',
						name: '一级',
						amount1: '234',
						amount2: '3.2',
						amount3: 10
					}, {
						id: '小12',
						name: '二级',
						amount1: '165',
						amount2: '4.43',
						amount3: 12
					}, {
						id: '小12',
						name: '三级',
						amount1: '324',
						amount2: '1.9',
						amount3: 9
					}, {
						id: '小12',
						name: '四级',
						amount1: '621',
						amount2: '2.2',
						amount3: 17
					}, {
						id: '小12',
						name: '五级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '小12',
						name: '六级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '小12',
						name: '七级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '小12',
						name: '八级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '大12',
						name: '一级',
						amount1: '234',
						amount2: '3.2',
						amount3: 10
					}, {
						id: '大12',
						name: '二级',
						amount1: '165',
						amount2: '4.43',
						amount3: 12
					}, {
						id: '大12',
						name: '三级',
						amount1: '324',
						amount2: '1.9',
						amount3: 9
					}, {
						id: '大12',
						name: '四级',
						amount1: '621',
						amount2: '2.2',
						amount3: 17
					}, {
						id: '大12',
						name: '五级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '大12',
						name: '六级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '大12',
						name: '七级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					},
					{
						id: '大12',
						name: '八级',
						amount1: '539',
						amount2: '4.1',
						amount3: 15
					}
				],
				arr1: [],
				arr2: [],
				jgcjtitle: '',

				// resPreferentialList:[
				// 	{
				// 		label:1,
				// 		value:1,
				// 	}
				// ],
				// resTerpList:[
				// 	{
				// 		label:1,
				// 		value:1,
				// 	}
				// ],
				//物料类型
				carNameModify: '',
				customerManagementList: [],
				solelist: [],
				enterpriseTwo:'',
				enterpriseTwoOptionList:[],
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: "",
				CZmoney: '',
				amountmaxlength: 10, //充值限额
				amountCapitalText: '',
				objaccount:{},
				tjzxsj:'',//调价时间
				yhtktjzxsj:''//优惠调控调价执行时间
			};
		},
		watch: {
			//监听器的作用就是用来监听数据是否发生了变化，变化后可以进行一些其他操作
			//只要没有发生变化，就没有办法进行其他的操作
			bb: function(newData, oldData) {
				//newData是更新后的数据
				//oldData是旧数据
				// newData.tel = 1111;
				// console.log("监听变化:", newData, oldData);
			},
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			if (path === "/SalesystemCorporateAccount") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.userobj = this.$store.state.uobj;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				// this.init();
			}




		},
		mounted() {
			// console.log(this.userobj.ormtb400)
			this.pageList()
			this.querycityNameList()

		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				currentPage: this.currentPage, //当前页数
				page: this.page, //页码
				limit: this.limit, //每页条数
			};
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {

			setdates(arr) {
				var obj = {},
					k, arr1 = [];
				for (var i = 0, len = arr.length; i < len; i++) {
					k = arr[i].name; //需要合并的字段
					if (obj[k])
						obj[k]++;
					else
						obj[k] = 1;
				}
				// console.log(obj)
				//保存结果{el-'元素'，count-出现次数}
				for (var o in obj) {
					for (let i = 0; i < obj[o]; i++) {
						if (i === 0) {
							this.arr1.push(obj[o])
						} else {
							this.arr1.push(0)
						}
					}
				}
				// console.log(this.arr1);

			},
			wllbFun() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB206CD01: '1002', 
					SETTB205ID: '05'
				}
				var url = "/set/settb206/select206List";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						console.log(res)
						
						this.customerManagementList = res.data.data
			
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},



			// objectSpanMethod({
			// 	row,
			// 	column,
			// 	rowIndex,
			// 	columnIndex
			// }) {
			// 	if (columnIndex === 0) {
			// 		if (rowIndex % 2 === 0) {
			// 			return {
			// 				rowspan: 2,
			// 				colspan: 1
			// 			};
			// 		} else {
			// 			return {
			// 				rowspan: 0,
			// 				colspan: 0
			// 			};
			// 		}
			// 	}
			// },

			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					let _row = this.arr1[rowIndex]
					let _col = this.arr1[rowIndex] > 0 ? 1 : 0
					return [_row, _col]
				}
			},


			reconstructionStuData(data) {
				// console.log(data)
				if (!Array.isArray(data)) return [];

				let tmpData = [];
				data.forEach((item, i) => {
					//有二级数据的进行处理
					if (Array.isArray(item.subject) && item.subject.length > 0) {
						//循环成绩
						item.subject.forEach((sub, j) => {
							let subData = {};
							if (j == 0) {
								//子项第一行数据，和姓名信息同行
								subData = Object.assign({}, item, sub);
							}
							//其他行数据无须添加 姓名字段信息（第一行数据会合并到结束位置，填充后也会被覆盖）
							else {
								subData = Object.assign({}, sub);
							}
							//if end
							tmpData.push(subData);
						});
					}
					//subject无子项数据，保留当前位置输出
					else {
						tmpData.push(
							Object.assign({}, item)
						);
					}
				});
				return tmpData;
			},

			customerManagementQuery() { //获取客户等级列表
				this.ruleForm.grade = []
				var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.ruleForm.grade = res.data.data
						this.editRuleForm.grade = res.data.data


					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			handleCheckAllChange(val) { //客户等级全选
				// console.log(val)
				// console.log(this.addEdit)
				if (this.addEdit == 0) {
					this.checkedCitiesGrade = val ? this.ruleForm.grade : [];
					// console.log(this.checkedCitiesGrade)
					this.isIndeterminate = false;
					return
				}
				if (this.addEdit == 1) {
					if (val == true && this.addEdit == 1) {
						for (let i = 0; i < this.editRuleForm.grade.length; i++) {
							// if (this.editRuleForm.grade[i].containPreferential == 1) {
							this.checkedCitiesGrade.push(this.editRuleForm.grade[i].SETTB206CA00);
							// console.log(this.checkedCitiesGrade)
							// }
						}
					} else {
						this.checkedCitiesGrade = []
					}
					this.isIndeterminate = false;


				}


			},
			handleCheckedCitiesChange(value) { //客户等级单选
				let checkedCount = value.length;
				// console.log(checkedCount)
				this.checkAllGrade = checkedCount === this.ruleForm.grade.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.ruleForm.grade.length;
				// console.log(value)
			},
			tabClick(row, column, cell, event) {
				// console.log("row:", row);
				// console.log("column:", column);
				// console.log("column.index:", column.index);
				// console.log("column.label:", column.label);

				this.clickRowIndex = row.index;
				this.clickCellIndex = column.index;
				this.tabClickLabel = column.label;

			},
			// 失去焦点初始化
			inputBlur(row, event, column) {
				// console.log(row)
				// console.log(event)
				// console.log(column)
				this.clickRowIndex = null;
				this.clickCellIndex = null;
				this.tabClickLabel = "";
				// console.log("this.tableData:", this.tableData);
			},
			changeInput(row) {
				// console.log(row)

				this.notice = row.notice
				this.ORMTB401ID = row.ORMTB401ID
				this.noticeFun()
			},

			tableRowClassName({
				row,
				rowIndex
			}) {
				row.index = rowIndex;
			},

			// 把每一列的索引放进column
			tableCellClassName({
				column,
				columnIndex
			}) {
				column.index = columnIndex;
			},

			newlyAdd() {
				this.insertShow = true
				this.enterpriseNameAdd = '' //企业名称
				// this.enterpriseAbbreviationAdd = '' //企业简称
				this.phoneNumberAdd = '' //手机号
				this.accountNameAdd = '' //账户名称
				this.accountBalanceAdd = '' //账户余额
				this.addressBalanceAdd = '' //地址
				// this.uditTypeAdd = '1'//派单审核
				this.cityNameAdd = ''
				this.cityCodeAdd = ''
			},
			querycityNameList() {
				var url = "/code/condtb01/selecList"
				var postData = {}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.cityNameList = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			cityNameChange(e) {
				this.cityNameList.forEach((resitme) => {
					if (this.cityCodeAdd == resitme.CODETB01CA00) {
						this.cityNameAdd = resitme.CODETB01CA01;
					}
				});
			},
			materialMLClick(row) {
				this.insertMLShow = true
				this.objCjMasg = row
				this.customerManagementQuery()
				this.checkedCitiesGrade = []
				this.isIndeterminate = false
				this.checkAllGrade = false
			},
      addAmountClick(row){
        this.addAmountShow = true
        this.objaccount = row
      },
			// 保存抹零设置
			preservationML() {
				if (this.checkedCitiesGrade.length == 0) {
					this.$message({
						message: '请选择客户等级',
						type: 'error'
					});
					return
				}
				let newArrKhdj = []
				this.checkedCitiesGrade.forEach(function(value, index, array) {
					newArrKhdj.push(value.SETTB206CA00)
				})
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.objCjMasg)
				var postData = {
					ORMTB401ID: this.objCjMasg.ORMTB401ID,
					ORMTB401CA08: newArrKhdj.toString() //客户等级
				}
				var url = "/orm/ormtb401/updateML";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertMLShow = false;
						this.$message({
							message: '设置成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},

			preservationXGML() { //修改抹零设置
				if (this.checkedCitiesGrade.length == 0) {
					this.$message({
						message: '请选择客户等级',
						type: 'error'
					});
					return
				}

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: this.objCjMasg.ORMTB401ID,
					ORMTB401CA08: this.checkedCitiesGrade.toString() //客户等级
				}
				var url = "/orm/ormtb401/updateML";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertXGMLShow = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})

			},
			
			preservationGBML(row) { //关闭抹零
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: row.ORMTB401ID,
					ORMTB401CA08: '' //客户等级
				}
				var url = "/orm/ormtb401/updateML";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertXGMLShow = false;
						this.$message({
							message: '关闭成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},

			// 新增
			preservationAdd() {
				if (this.enterpriseNameAdd.trim().length == 0) return this.$message.error('请输入企业名称')
				// if (this.enterpriseAbbreviationAdd.trim().length == 0) return this.$message.error('请输入企业简称')
				if (this.phoneNumberAdd.trim().length == 0) return this.$message.error('请输入手机号')
				if (this.phoneNumberAdd != '') {
					var regP = /^1[3-9][0-9]{9}$/;
					if (!regP.test(this.phoneNumberAdd))
						return this.$message.error("请输入有效手机号");
				}
				if (this.accountNameAdd.trim().length == 0) return this.$message.error('请输入账户名称')
				if (this.accountBalanceAdd === '') return this.$message.error('请输入账户余额')
				if (this.addressBalanceAdd.trim().length == 0) return this.$message.error('请输入地址')
				if (this.cityCodeAdd.trim().length == 0) return this.$message.error('请选择市名称')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB100CA00: this.enterpriseNameAdd, //企业名称
					// SETTB100CA01: this.enterpriseAbbreviationAdd, //企业简称
					ORMTB400CA02: this.phoneNumberAdd, //手机号
					ORMTB401CA02: this.accountNameAdd, //账户名称
					ORMTB401CA03: this.accountBalanceAdd, //账户余额
					SETTB99CA02: this.addressBalanceAdd, //地址
					SETTB100CA04: this.cityCodeAdd, //市代码
					SETTB100CA05: this.cityNameAdd, //市名称
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
					// Notice: this.notice, //公告
					// SETTB100CA03:this.uditTypeAdd
				}
				var url = "/orm/ormtb401/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertShow = false;
						// this.$message({
						// 	message: '新增成功',
						// 	type: 'success'
						// });
						this.$alert('新增成功，请前去销售系统-优惠管理中为该新建企业设置等级优惠。', '消息', {
							confirmButtonText: '确定'
						})
						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			// 修改
			modify(item) {
				this.updateShow = true
				this.enterpriseNameModify = item.SETTB100CA00 //企业名称
				// this.enterpriseAbbreviationModify = item.SETTB100CA01 //企业简称
				this.phoneNumberModify = item.SETTB99CA05 //手机号
				this.accountNameModify = item.ORMTB401CA02 //账户名称
				this.accountBalanceModify = item.ORMTB401CA03 //账户余额
				this.addressBalanceModify = item.SETTB99CA02 //地址
				this.ORMTB401ID = item.ORMTB401ID //帐户ID
				this.ORMTB401CA00 = item.ORMTB401CA00 //一级企业ID
				this.SETTB99ID = item.SETTB99ID //二级企业ID
				this.notice = item.notice,
					this.modifyIF = item.ORMTB401CA01 || 'ZJ'
				this.uditTypeUpdate = item.SETTB100CA03 || '1'
				this.cityCodeModify = item.SETTB100CA04
				this.cityNameModify = item.SETTB100CA05
			},
			cityNameChangeModify(e) {
				this.cityNameList.forEach((resitme) => {
					if (this.cityCodeModify == resitme.CODETB01CA00) {
						this.cityNameModify = resitme.CODETB01CA01;
					}
				});
			},
			preservationModify() {
				// console.log(this.phoneNumberModify)
				if (this.enterpriseNameModify.trim().length == 0) return this.$message.error('请输入企业名称')
				// if (this.enterpriseAbbreviationModify.trim().length == 0) return this.$message.error('请输入企业简称')
				if (this.phoneNumberModify == undefined) return this.$message.error('请输入手机号')
				if (this.phoneNumberModify.trim().length == 0) return this.$message.error('请输入手机号')
				if (this.phoneNumberModify != '') {
					var regP = /^1[3-9][0-9]{9}$/;
					if (!regP.test(this.phoneNumberModify))
						return this.$message.error("请输入有效手机号");
				}
				if (this.accountNameModify.trim().length == 0) return this.$message.error('请输入账户名称')
				if (this.accountBalanceModify === '') return this.$message.error('请输入账户余额')
				if (this.addressBalanceModify.trim().length == 0) return this.$message.error('请输入地址')
				if (this.cityCodeModify.trim().length == 0) return this.$message.error('请选择市名称')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB100CA00: this.enterpriseNameModify, //企业名称
					// SETTB100CA01: this.enterpriseAbbreviationModify, //企业简称
					ORMTB400CA02: this.phoneNumberModify, //手机号
					ORMTB401CA02: this.accountNameModify, //账户名称
					ORMTB401CA03: this.accountBalanceModify, //账户余额
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
					ORMTB401ID: this.ORMTB401ID, //帐户ID
					SETTB100ID: this.ORMTB401CA00, //一级企业ID
					SETTB99ID: this.SETTB99ID, //二级企业ID
					// notice: this.notice,
					SETTB99CA02: this.addressBalanceModify, //地址
					SETTB100CA03: this.uditTypeUpdate,
					SETTB100CA04: this.cityCodeModify, //市代码
					SETTB100CA05: this.cityNameModify, //市名称
				}
				var url = "/orm/ormtb401/compile";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.updateShow = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			captchaBinding(item) {
				this.bindingShow = true
				// this.phoneBinding=item.SETTB99CA01
				this.phoneBinding = ''
				this.nameBinding = '';
				this.enterpriseTwo = '';
				this.codeNumBinding = '';
				this.SETTB107ID = '';
				this.zzhphoneBinding = '';
				// this.nameBinding=item.ORMTB401CA02
				this.ORMTB401ID = item.ORMTB401ID
				this.ORMTB401CA00 = item.ORMTB401CA00
			},
			erpChange(e){
				this.enterpriseTwo = e.SETTB107ID;
				this.nameBinding = e.SETTB107CA00;
				// this.nameBinding = this.enterpriseTwo
			},


			phoneBindingUp() {

				var postData = {
					ORMTB400CA02: this.phoneBinding, //主手机号
					ORMTB400CA03: this.zzhphoneBinding, //子手机号
					SETTB107ID: this.enterpriseTwo,
					ORMTB401CA00: this.ORMTB401CA00 //一级企业id
				}
				var url = "/orm/ormtb401/checkOrmtb400ca02";
				if (this.phoneBinding.length == 11) {
					this.axios.post(url, postData).then(res => {
						console.log(res)
						if (res.data.code == 200) {
							var moLists = res.data.data;
							this.enterpriseTwoOptionList = moLists
							this.enterpriseTwo = moLists[0].SETTB107ID
							this.nameBinding = moLists[0].SETTB107CA00;
							this.SETTB107ID = moLists[0].SETTB107ID;
							this.SETTB116ID = moLists[0].SETTB116ID;
							this.SETTB116CA01 = moLists[0].SETTB116CA01;
							this.zzhphoneBinding = moLists[0].SETTB116CA00;
							this.$message({
								message: res.data.message,
								type: 'success'
							});
						} 
						
						if(res.data.code == 201){
							this.$message({
								message: res.data.message,
								type: 'success'
							});
							this.countdown()
						}
						if(res.data.code == 500){
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				} else if (this.phoneBinding.length == 0) {
					this.nameBinding = '';
					this.SETTB107ID = '';
					this.enterpriseTwoOptionList = [];
					this.enterpriseTwo = '';
				}
			},




			noticeFun() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: this.ORMTB401ID, //ID
					notice: this.notice, //公告
				}
				var url = "/orm/ormtb401/updateNotice";

				this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
					.catch(() => {
						loading.close();
					})

			},

			preservationBinding() {
				if (this.phoneBinding.trim().length == 0) return this.$message.error('请输入手机号')
				if (this.phoneBinding != '') {
					var regP = /^1[3-9][0-9]{9}$/;
					if (!regP.test(this.phoneBinding))
						return this.$message.error("请输入有效手机号");
				}
				var NumBin = /^\d{6}$/;
				if (!NumBin.test(this.codeNumBinding)) return this.$message.error('请输入六位有效验证码')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401CA00: this.ORMTB401CA00,
					ORMTB400CA02: this.phoneBinding, //主手机号
					SETTB116CA00: this.zzhphoneBinding, //子手机号
					SETTB116CA01: this.SETTB116CA01,
					SETTB116ID: this.SETTB116ID,
					PERTB006CA00: this.codeNumBinding,
					ORMTB401ID: this.ORMTB401ID,
					SETTB107ID: this.enterpriseTwo,
					SETTB107CA00: this.nameBinding,
				}
				var url = "/orm/ormtb401/update";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.bindingShow = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			countdown() { //倒计时
				// console.log(this.ueseinfo.name)
				if ((/^[1][3-9][0-9]{9}$/.test(this.phoneBinding))) {
					this.checkDisable = true
					this.countdownNum--
					this.checkText = `${this.countdownNum}后重新获取`
					var time = setInterval(() => {
						if (this.countdownNum == 0) {
							clearInterval(time)
							this.countdownNum = 60
							this.checkText = '获取验证码'
							this.checkDisable = false
							return
						} else {
							this.countdownNum--
							var num = this.countdownNum < 10 ? ('0' + this.countdownNum) : this.countdownNum
							this.checkText = `${num}后重新获取`
						}
					}, 1000)
					var url = '/orm/ormtb401/getCode'
					var data = {
						ORMTB400CA02: this.phoneBinding,
						ORMTB400CA03: this.zzhphoneBinding
					}
					this.axios.post(url, data).then((res) => {
						// console.log(res)
						if (res.data.code != 200) {
							this.$message.error('获取验证码失败，请重试！')
						}
					})
				} else {
					this.$message.error('请输入有效手机号')
				}
			},
			// 查看物料
			// 新增
			MaterialAdd() {
				this.materInsertShow = true
				// this.enterNameMaterialAdd='' //企业名称
				this.nameMaterialAdd = '' //物料名称
				this.wholesalePriceAdd = '' //零售价格
				// this.agreementPriceAdd='' //协议价格
				this.materialTypeAdd = '' //物料类型
				this.unitMeasurementAdd = '' //计量单位
				this.queryMaterialTypeLsit('')
				this.wllbFun()
			},
			preservationMaterialAdd() {
				if (this.nameMaterialAdd.trim().length == 0) return this.$message.error('请输入物料名称')
				if (this.wholesalePriceAdd === '') return this.$message.error('请输入零售价格')
				// if (this.agreementPriceAdd=== '') return this.$message.error('请输入协议价格')
				if (this.materialTypeAdd.trim().length == 0) return this.$message.error('请输入物料类型')
				if (this.unitMeasurementAdd.trim().length == 0) return this.$message.error('请输入计量单位')
				if (this.carNameModify == '') return this.$message.error('请选择物料类型')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB99CA00: this.enterNameMaterialAdd, //二级企业名称
					SETTB109CA00: this.nameMaterialAdd, //物料名称
					SETTB109CA01: this.wholesalePriceAdd, //零售价格
					// SETTB109CA01: this.agreementPriceAdd, //协议价格
					SETTB206CA00: this.materialTypeAdd, //装车方式
					SETTB206CA00: this.materialTypeAdd, //装车方式
					SETTB109CB00: this.carNameModify,//物料类型
					SETTB109CA05: this.unitMeasurementAdd, //计量单位
					SETTB109CD01: this.ORMTB401CA00, //一级企业id
					// ORMTB401ID: this.ORMTB401ID,//一级企业id
					SETTB99ID: this.SETTB99ID, //二级企业id
				}
				var url = "/set/settb109/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.materInsertShow = false;
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.pageMaterialList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			queryMaterialTypeLsit(type) {
				// console.log(type)
				if (type === 0) {
					this.materialTypeList = [{
						SETTB206CA00: "",
						SETTB206CA01: "全部"
					}];
				} else {
					this.materialTypeList = []
				}
				var url = "/set/settb109/selectSETTB206CA01"
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data
						if (type === 0) {
							this.materialTypeList = [...this.materialTypeList, ...data];
						} else {
							this.materialTypeList = data
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			MaterialModify(item) {
				this.materupdateShow = true
				this.queryMaterialTypeLsit('')
				this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
				this.nameMaterialModify = item.SETTB109CA00 //物料名称
				this.wholesalePriceModify = item.SETTB109CA01 //价格
				this.wholesalePriceBefore = item.SETTB109CA01 //价格
				this.materialTypeModify = item.SETTB206CA00 //物料类型
				this.unitMeasurementModify = item.SETTB109CA05 //计量单位
				this.MaterialModify109ID = item.SETTB109ID
			},

			DiscountModify(item) {
				// console.log(item)
				this.discountShow = true
				// this.queryMaterialTypeLsit('')
				this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
				this.nameMaterialModify = item.SETTB109CA00 //物料名称
				this.floatingAmount = item.SETTB109CB02 //浮动金额
				this.floatingType = item.SETTB109CB01 //浮动类型-上浮/下调
				// this.wholesalePriceModify = item.SETTB109CA01 //价格
				// this.wholesalePriceBefore = item.SETTB109CA01 //价格
				// this.materialTypeModify = item.SETTB206CA00 //物料类型
				// this.unitMeasurementModify = item.SETTB109CA05 //计量单位
				this.MaterialModify109ID = item.SETTB109ID
			},
			locationSet(row) {
				this.locationShow = true
				this.locationSetObj = row
				// console.log(this.locationSetObj)
			},

			preservationMaterialModify() {
				if (this.nameMaterialModify.trim().length == 0) return this.$message.error('请输入物料名称')
				if (this.wholesalePriceModify === '') return this.$message.error('请输入价格')
				// if (this.agreementPriceModify=== '') return this.$message.error('请输入协议价格')
				if (this.materialTypeModify.trim().length == 0) return this.$message.error('请选择物料类型')
				if (this.unitMeasurementModify.trim().length == 0) return this.$message.error('请输入计量单位')
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
					SETTB109ID: this.MaterialModify109ID, //物料ID
					SETTB109CA00: this.nameMaterialModify, //物料名称
					SETTB109CA01: this.wholesalePriceModify, //修改之后价格
					// SETTB109CA01: this.agreementPriceModify, //协议价格
					SETTB206CA00: this.materialTypeModify, //物料类型
					SETTB109CA05: this.unitMeasurementModify, //计量单位
					before: this.wholesalePriceBefore, //修改之前的价格
					SETTB100ID: this.ORMTB401CA00, //一级企业id
					SETTB99ID: this.SETTB99ID, //二级企业id
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
					ORMTB408CA02: this.userobj.pertb005.pertb005ca02, //当前登录人名称
					SETTB109CB13:this.tjzxsj//调价执行时间
				}
				var url = "/set/settb109/update";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.materupdateShow = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.pageMaterialList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},

			preservationDiscountModify() {
				if (this.floatingType === '') return this.$message.error('请选择浮动类型')
				if (this.floatingAmount == undefined) return this.$message.error('请输入浮动金额')

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
					SETTB109ID: this.MaterialModify109ID, //物料ID
					SETTB109CB01: this.floatingType, //上浮-下浮
					SETTB109CB02: this.floatingAmount ,//浮动金额
					SETTB109CB13: this.yhtktjzxsj,//优惠调控调价执行时间
					// SETTB109CA00: this.nameMaterialModify, //物料名称
					// SETTB109CA01: this.wholesalePriceModify, //修改之后价格
					// // SETTB109CA01: this.agreementPriceModify, //协议价格
					// SETTB206CA00: this.materialTypeModify, //物料类型
					// SETTB109CA05: this.unitMeasurementModify, //计量单位
					// before: this.wholesalePriceBefore, //修改之前的价格
					// SETTB100ID: this.ORMTB401CA00, //一级企业id
					// SETTB99ID: this.SETTB99ID, //二级企业id
					// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
					// ORMTB408CA02: this.userobj.pertb005.pertb005ca02, //当前登录人名称
				}
				var url = "/set/settb109/updateSETTB109CB02";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.discountShow = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.pageMaterialList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			locationSetObjModify() {
				// console.log(this.locationSetObj.SETTB109CB06)
				if (!this.locationSetObj.SETTB109CB06) return this.$message.error('请输入库位信息')

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
					SETTB109ID: this.locationSetObj.SETTB109ID, //物料ID
					SETTB109CB06: this.locationSetObj.SETTB109CB06
				}
				var url = "/set/settb109/updateSETTB109CB06";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.locationShow = false;
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.pageMaterialList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},

			// 禁用
			disableClick(row) {
				var SETTB109ID = row["SETTB109ID"]; //物料id
				var SETTB109CA02 = row["SETTB109CA02"]; //状态--1启用，0禁用
				var state;
				var ediqj
				if (SETTB109CA02 == "禁用") {
					state = 1;
					ediqj = 1;
				} else if (SETTB109CA02 == "启用") {
					state = 0;
					ediqj = 0
				}
				var postData = {
					SETTB109ID: SETTB109ID, //物料id
					SETTB109CA02: state, //状态
					SETTB109CB04: ediqj,
				};
				var url = "/set/settb109/updateSettb109ca02";
				if (state == 1) {
					this.$confirm("此操作将启用该条数据, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						this.axios.post(url, postData).then((res) => {
							// console.log(res)
							if (res.data.code == 200) {
								this.pageMaterialList();
								this.$message({
									type: "success",
									message: "启用成功!",
								});
							} else {
								this.$message({
									message: res.data.message,
									type: "error",
								});
							}
						});
					});
				} else if (state == 0) {
					this.$confirm("此操作将禁用该条数据, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						this.axios
							.post(url, postData)
							.then((res) => {
								// console.log(res)
								if (res.data.code == 200) {
									this.pageMaterialList();
									this.$message({
										type: "success",
										message: "禁用成功!",
									});
								} else {
									this.$message({
										message: res.data.message,
										type: "error",
									});
								}
							})
							.catch((err) => {
								this.$baseAPI.axiosstatusMsg(err);
							});
					});
				}
			},

			tgClick(row) {
				var url = "set/settb109/updateSETTB109CA11"
				var SETTB109ID = row["SETTB109ID"]; //物料id
				var SETTB109CA09 = row["SETTB109CA09"]; //视频路径
				var postData = {
					SETTB109ID: SETTB109ID,
					SETTB109CA11: 1,
					SETTB109CA09: SETTB109CA09
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.pageMaterialList();
						this.$message({
							type: "success",
							message: "已通过!",
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},

			// 是否优惠
			changeTable(row) {
				var str = row.SETTB109CA08 == 0 ? '关闭' : '开启'
				var url = "/set/settb109/updateSETTB109CA08"
				var postData = {
					SETTB109ID: row.SETTB109ID,
					SETTB109CA08: row.SETTB109CA08,
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: `${str}成功`,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
					this.pageMaterialList()
				}).catch(() => {
					loading.close()
					this.pageMaterialList()
				})
			},

			// 是否启用多账户
			changeMultipleAccountsTable(row) {
				var str = row.SETTB109CB09 == 0 ? '关闭' : '开启'
				var url = "/set/settb109/updateSettb109CB09"
				var postData = {
					SETTB109ID: row.SETTB109ID,
					SETTB109CB09: row.SETTB109CB09,
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: `${str}成功`,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
					this.pageMaterialList()
				}).catch(() => {
					loading.close()
					this.pageMaterialList()
				})
			},

			materialClick(item) {
				this.materShow = true
				this.categoryMaterial = ''
				this.nameMaterial = ''
				this.ORMTB401CA00 = item.ORMTB401CA00
				this.SETTB99ID = item.SETTB99ID
				this.enterNameMaterialAdd = item.SETTB99CA00
				this.materiaShowZJ = item.ORMTB401CA01 //企业是绑定还是自建
				this.ORMTB401ID = item.ORMTB401ID //帐户ID
				this.pageMaterial = 1

				this.queryMaterialTypeLsit(0)
				this.pageMaterialList()
			},

			// 查看价格
			jgApiFun(SETTB99ID, SETTB99CA00) {
				var url = "/orm/ormtb401/loadTree"
				var postData = {
					SETTB99ID: SETTB99ID,
					SETTB99CA00: SETTB99CA00,
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData1 = res.data.data.trees
						this.setdates(this.tableData1)
						// this.$nextTick(() => {
						// 	this.JGechartsVive();
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},


			materialJGClick(row) {
				// console.log(row)
				this.jgApiFun(row.SETTB99ID, row.SETTB99CA00)
				this.jgcjtitle = row.SETTB100CA00
				this.insertJGShow = true


			},
			initEchs() {
				let myChart = this.$echarts.init(this.$refs.maim)
				this.$nextTick(() => {
					option && myChart.setOption(option)
					const eleArr = Array.from(new Set(myChart._chartsViews[0]._data._graphicEls))
					// const treeDepLength = myChart._chartsViews[0]._data.tree.root.height                            // 获取树的高度
					// const itemHeight = 100       // 设置每层树的间距（垂直型树高）
					// let currentHeight = itemHeight * (treeDepLength + 1) || itemHeight
					const itemHeight = 30
					const currentHeight = itemHeight * (eleArr.length - 1) || itemHeight
					const newHeight = Math.max(currentHeight, itemHeight)
					this.chartHeight = newHeight
					myChart.resize({
						height: newHeight
					})
				})
			},
			JGechartsVive() {
				let myChart = this.$echarts.init(document.getElementById('JGChart'))

				var option;
				option = {
					tooltip: {
						trigger: 'item',
						triggerOn: 'mousemove'
					},
					// legend: {
					// 	top: '2%',
					// 	left: '3%',
					// 	orient: 'vertical',
					// 	data: [{
					// 			name: 'tree1',
					// 			icon: 'rectangle'
					// 		},
					// 		{
					// 			name: 'tree2',
					// 			icon: 'rectangle'
					// 		}
					// 	],
					// 	borderColor: '#c23531'
					// },
					series: [{
						type: 'tree',
						name: 'tree2',
						data: [this.jgData],
						top: '0',
						left: '10%',
						bottom: '10%',
						right: '10%',
						avoidLabelOverlap: true, //防止标签重叠
						roam: true, //移动+缩放  'scale' 或 'zoom'：只能够缩放。 'move' 或 'pan'：只能够平移。
						scaleLimit: { //缩放比例
							min: 0.7, //最小的缩放值
							max: 4, //最大的缩放值  
						},

						layout: 'orthogonal', //树图布局，orthogonal水平垂直方向，radial径向布局 是指以根节点为圆心，每一层节点为环，一层层向外
						orient: 'TB', //树形方向  TB为上下结构  LR为左右结构
						// nodePadding: 100,//结点间距 （发现没用）
						//layerPadding: 30,//连接线长度 （发现没用）
						symbol: 'circle', //图形形状  rect方形  roundRect圆角 emptyCircle圆形 circle实心圆
						symbolSize: 14, //状态大小
						edgeShape: 'polyline', //线条类型  curve曲线
						initialTreeDepth: 6, //初始展开的层级
						// expandAndCollapse: true, //子树折叠和展开的交互，默认打开
						lineStyle: { //结构线条样式
							width: 0.7,
							color: '#1E9FFF',
							type: 'broken'
						},
						label: { //节点文本样式
							normal: {
								backgroundColor: '#81c5f7',
								position: 'bottom',
								verticalAlign: 'middle', //文字垂直对齐方式
								align: 'center',
								borderColor: '#1E9FFF',
								color: '#fff',
								borderWidth: 1,
								borderRadius: 5,
								padding: 5,
								height: 40,
								width: 100,
								offset: [0, 30], //节点文字与圆圈之间的距离
								fontSize: 15,
								// 节点文本阴影
								shadowBlur: 10,
								shadowColor: 'rgba(0,0,0,0.25)',
								shadowOffsetX: 0,
								shadowOffsetY: 2,
							}
						},

						// layout: 'radial',
						// symbol: 'emptyCircle',
						// symbol: 'emptyCircle',
						// orient: 'vertical',
						// symbolSize: 7,
						// label: {
						// 	position: 'left',
						// 	verticalAlign: 'middle',
						// 	align: 'right',
						// 	fontSize: 12
						// },
						leaves: {
							// label: {
							// 	position: 'right',
							// 	verticalAlign: 'middle',
							// 	align: 'left'
							// }

							label: {
								//backgroundColor: '#81c5f7',
								backgroundColor: '#fff',
								color: '#333',
								position: 'bottom',
								rotate: 0, //标签旋转。
								verticalAlign: 'middle',
								align: 'center',
								//文本框内文字超过6个字折行
								/* formatter: function(val) {
												 let strs = val.name.split(''); //字符串数组
												 let str = ''
												 for(let i = 0, s; s = strs[i++];) { //遍历字符串数组
												   str += s;
												   if(!(i % 6)) str += '\n'; //按需要求余，目前是一个字换一行
												 }
												 return str
											   }, */
								//或者 
								overflow: 'break', //break为文字折行，  truncate为文字超出部分省略号显示
								lineOverflow: 'truncate', //文字超出高度后 直接截取
							}

						},
						expandAndCollapse: true, //点击锚点显示或隐藏，true可以点击，false不可以点击
						emphasis: {
							focus: 'descendant'
						},
						animationDuration: 550,
						// initialTreeDepth: 3,
						animationDurationUpdate: 750
					}]
				};
				option && myChart.setOption(option);
				const eleArr = Array.from(new Set(myChart._chartsViews[0]._data._graphicEls))
				// const treeDepLength = myChart._chartsViews[0]._data.tree.root.height                            // 获取树的高度
				// const itemHeight = 100       // 设置每层树的间距（垂直型树高）
				// let currentHeight = itemHeight * (treeDepLength + 1) || itemHeight
				const itemHeight = 15
				const currentHeight = itemHeight * (eleArr.length - 1) || itemHeight
				const newHeight = Math.max(currentHeight, itemHeight)
				this.chartHeight = newHeight
				let layer_width = 15; // 兄弟节点之间的距离
				let currentWidth = layer_width * (eleArr.length - 1) || layer_width;
				let newWidth = Math.max(currentWidth, layer_width);
				this.chartWidth = newWidth + 'px';
				// myChart.resize({
				// 	// height: newHeight,
				// 	width:newWidth,
				// })
				window.onresize = function() {
					myChart.resize();
				}
			},
			undercarriageClick(item) { //下架厂家
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: item.ORMTB401ID,
					ORMTB401CA09: 1 //状态
				}
				var url = "/orm/ormtb401/underEnter";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertXGMLShow = false;
						this.$message({
							message: '下架成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			groundingClick(item) { //上架厂家
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: item.ORMTB401ID,
					ORMTB401CA09: 0 //状态
				}
				var url = "/orm/ormtb401/underEnter";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertXGMLShow = false;
						this.$message({
							message: '上架成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			wlztClick(item, start) { //网络状态
				console.log(start)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB401ID: item.ORMTB401ID,
					ORMTB401CA13: start //开启或关闭
				}
				var url = "/orm/ormtb401/setOffline";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.insertXGMLShow = false;
						this.$message({
							message: '成功',
							type: 'success'
						});

						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},

			modifyMLClick(row) {
				// console.log(row)
				this.customerManagementQuery()
				this.addEdit = 1
				this.objCjMasg = row
				var khmr = row.ORMTB401CA08.split(',') //客户等级

				this.checkedCitiesGrade = khmr;

				this.checkAllGrade = khmr.length === this.editRuleForm.grade.length;
				let _this = this
				setTimeout(function() {
					_this.checkAllGrade = khmr.length === _this.editRuleForm.grade.length;

					_this.isIndeterminate = khmr.length > 0 && khmr.length < _this.editRuleForm.grade.length;



				}, 500);

				this.insertXGMLShow = true
			},


			MaterialQuery() {
				this.pageMaterial = 1
				this.pageMaterialList()
			},
			// 列表
			pageMaterialList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB109CA03: this.categoryMaterial, //物料类别
					SETTB109CA00: this.nameMaterial, //物料名称
					SETTB109CD01: this.ORMTB401CA00, //一级企业id
					SETTB99ID: this.SETTB99ID, //二级企业ID
					ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
					page: this.pageMaterial,
					limit: this.limitMaterial
				}
				this.materList = [];
				var moList;
				var url = "/set/settb109/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						moList = res.data.data;
						for (var i = 0; i < moList.length; i++) {
							if (moList[i]["SETTB109CA02"] == 0) {
								moList[i]["SETTB109CA02"] = "禁用";
							} else if (moList[i]["SETTB109CA02"] == 1) {
								moList[i]["SETTB109CA02"] = "启用";
							}
						}
						this.materList = moList;
						this.pagingPageMaterial = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChangeMaterial(val) {
				this.pageMaterial = 1
				this.limitMaterial = val;
				this.pageMaterialList();
			},
			// 点击页码
			handleCurrentChangeMaterial(val) {
				this.pageMaterial = val;
				this.pageMaterialList();
			},
			// 企业
			accountBalanceAddUp() {
				var value = this.accountBalanceAdd;
				// this.accountBalanceAdd = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if (num <= 0) return
				if (num > 99999999.99)
					this.$message.error('单价高于最大限制99999999.99')
				num = num > 99999999.99 ? 99999999.99 : num
				this.accountBalanceAdd = num
			},
			accountBalanceModifyUp() {
				var value = this.accountBalanceModify;
				// this.accountBalanceModify = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if (num <= 0) return
				if (num > 99999999.99)
					this.$message.error('单价高于最大限制99999999.99')
				num = num > 99999999.99 ? 99999999.99 : num
				this.accountBalanceModify = num
			},
			// 物料
			wholesalePriceAddUp() {
				var value = this.wholesalePriceAdd;
				// this.wholesalePriceAdd = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if (num <= 0) return
				if (num > 99999999.99)
					this.$message.error('单价高于最大限制99999999.99')
				num = num > 99999999.99 ? 99999999.99 : num
				this.wholesalePriceAdd = num
			},
			// agreementPriceAddUp() {
			// 	var value = this.agreementPriceAdd;
			// 	this.agreementPriceAdd = this.clearNoNum(value);
			// },
			wholesalePriceModifyUp() {
				var value = this.wholesalePriceModify;
				// this.wholesalePriceModify = this.clearNoNum(value);
				var num = this.clearNoNum(value);
				if (num <= 0) return
				if (num > 99999999.99)
					this.$message.error('单价高于最大限制99999999.99')
				num = num > 99999999.99 ? 99999999.99 : num
				this.wholesalePriceModify = num
			},
			// agreementPriceModifyUp() {
			// 	var value = this.agreementPriceModify;
			// 	this.agreementPriceModify = this.clearNoNum(value);
			// },
			clearNoNum(value) {
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				return value;
			},
			// 查询
			queryClick() {
				this.page = 1
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					phone: this.retrievalQuery,
					SETTB94CA00: '1001', //对接平台代码
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
					page: this.page,
					limit: this.limit
				}
				this.tableData = [];
				var url = "/orm/ormtb401/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.tableData.forEach(item => {
							item.SETTB100CA03text = item.ORMTB401CA01 == 'BD' ? '直连' : '自建'
							Object.assign(item, {
								showInput: true
							})
						})
						// console.log(this.tableData)

						this.pagingPage = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChange(val) {
				this.page = 1
				this.limit = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.page = val;
				this.pageList();
			},
      topMoneyInput() { //充值金额实时校验
        // console.log(this.CZmoney)
        this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
        this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        if (this.CZmoney.indexOf(".") < 0 && this.CZmoney != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          this.CZmoney = parseFloat(this.CZmoney);
        }
        this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
        // this.$refs.topMoney.value = this.CZmoney
        this.amountCapitalText = this.priceChange(this.CZmoney)

      },
      priceChange(number) {
        var ret = "";
        if (number != "" && number != null && number != "0") {
          var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
              str = "";
          number += "00";
          var point = number.indexOf(".");
          if (point >= 0) {
            number = number.substring(0, point) + number.substr(point + 1, 2);
          }
          unit = unit.substr(unit.length - number.length);
          for (var i = 0; i < number.length; i++) {
            str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
          }
          ret =
              str
                  .replace(/零(仟|佰|拾|角)/g, "零")
                  .replace(/(零)+/g, "零")
                  .replace(/零(万|亿|元)/g, "$1")
                  .replace(/(亿)万|(拾)/g, "$1$2")
                  .replace(/^元零?|零分/g, "")
                  .replace(/元$/g, "元");
        }
        return ret;
      },
      topMoneyChange() { //充值金额失去焦点数据处理
        var index = String(this.CZmoney).indexOf('.')
        if (index == -1) return
        var numArr = this.CZmoney.split('.')
        if (numArr[1].length == 0) {
          this.$refs.topMoney.value = numArr[0]
          this.CZmoney = numArr[0]
        } else {
          this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
          this.CZmoney = numArr[0] + '.' + numArr[1]
        }
      },
      CZserve() {
        var url = "/orm/ormtb401/addAmount"
        var loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        var postData = {
          ORMTB401ID: this.objaccount.ORMTB401ID,
          AMOUNT: this.CZmoney
        }
        this.axios.post(url, postData).then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.$message.success('充值成功')
            this.pageList()
            this.addAmountShow=false
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        }).catch(() => {
          loading.close()
        })
      },
		},
	};
</script>

<style scoped>
	.systemCorporateAccount {
		background-color: #f3f3f3;
	}

	.systemCorporateAccount-table {
		text-align: center;
	}

	.test111:active {
		background-color: red !important;
	}

	.systemCorporateAccount-display,
	.systemCorporateAccount-wuliao-input {
		display: flex;
		flex-direction: row;
		align-items: center !important;
	}

	.systemCorporateAccount-optionSty {
		width: 140px;
		margin-right: 30px;
	}

	.systemCorporateAccount-wuliao-input>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}

	.systemCorporateAccount-dialog {
		padding: 0 20px;
	}

	.systemCorporateAccount-dialog-li {
		display: flex;
		box-sizing: border-box;
	}

	.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li {
		margin-top: 20px;
	}

	.SCADL-text {
		height: 30px;
		line-height: 30px;
		flex: .35;
		font-size: 18px;
		color: #333;
	}

	.SCADL-text span {
		color: red;
	}

	.SCADL-input {
		flex: 1;
		box-sizing: border-box;
	}

	.SCADL-input input {
		height: 40px;
		line-height: 30px;
		width: 99.9%;
		padding-left: 10px;
		border: 1px solid #999;
		color: #333;
		font-size: 18px;
		border-radius: 5px;
		box-sizing: border-box;
	}


	.Binding-input {
		display: flex;
	}

	.Binding-input .el-button {
		height: 40px !important;
		line-height: 40px !important;
		width: 30% !important;
		margin-left: 30px;
	}

	.Binding-input .el-input {
		width: 50% !important;
		height: 40px !important;
		line-height: 40px !important;
	}

	.Binding-input .el-input .el-input__inner {
		height: 40px !important;
		line-height: 40px !important;
	}

	.SCADL-input .el-select {
		width: 99.9%;
		height: 40px !important;
		line-height: 40px !important;
	}

	.systemCorporateAccount-dialog-btn {
		text-align: center;
		margin-top: 40px;
	}

	.systemCorporateAccount-dialog-li .CADL-binding-input {
		border: none;
		outline: none;
	}

	.SCADL-btn input {
		display: inline-block;
		width: 65%;
	}

	.SCADL-btn .el-button {
		height: 30px;
		line-height: 30px;
		padding: 0 20px;
	}

	.systemCorporateAccount-dialog-operation-btn {
		margin-top: 20px;
	}

	.systemCorporateAccount-dialog .pulbic_oparetionBlock {
		padding-left: 0;
		padding-right: 0;
	}

	.systemCorporateAccount-dialog-operation-btn-add {
		background-color: #ffaa00;
	}

	.SCADL-input .el-select .el-input__inner {
		height: 40px !important;
		line-height: 40px !important;
	}

	.levelmang-table-KJ {
		width: 240px;
	}

	.JGChart {
		height: 615px;
	}

	/deep/.SCADL-input .el-textarea .el-textarea__inner {
		/* height: 40px;
		line-height: 30px; */
		width: 99.9%;
		padding-left: 10px;
		border: 1px solid #999;
		color: #333;
		font-size: 18px;
		border-radius: 5px;
		font-family: Microsoft YaHei;
		/* box-sizing: border-box; */
		/* font-weight: bold; */
	}
</style>
